
import { Observable, of as observableOf } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'
import { formatProducts, setProducts } from 'services/product'
import { accessTokenSelector } from 'services/users/selectors'
import { StoreThunkAction, StoreThunkDispatch, getState } from 'store/state'
import * as net from './net'
import { PPProduct } from 'shared'

export function createAccount(args: {
  firstName: string,
  lastName: string,
  email: string,
  password?: string,
  captchaToken: string,
  fbId?: string,
  securityCode?: string,
  teamHash?: string,
  subscribeEmails?: boolean
}): StoreThunkAction<Observable<any>> {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(net.createAccount(args))
      .pipe(
        tap((response: any) => {
          if (response.subscriptions?.products) {
            const products = formatProducts(response.subscriptions.products as PPProduct[])
            dispatch(setProducts(products))
          }
        }),
        catchError((e) => observableOf({ error: e.response.error }))
      )
  }
}

export function checkout(
  user: {
    firstName: string
    lastName: string
    email: string,
    loginOtt?: string
  },
  productHandle: string,
  chargifyToken: string,
  currency: string,
  couponCode?: string,
  referralCode?: string
) {
  return (dispatch: StoreThunkDispatch, getState: getState) => {
    const isLoggedIn = Boolean(accessTokenSelector(getState()))
    return dispatch(net.checkout(user, productHandle, chargifyToken, currency, isLoggedIn, couponCode, referralCode))
      .pipe(catchError((e) => observableOf({ error: e.response.error })))
  }
}

export function validateCouponCode(code: string, productHandle: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(net.validateCouponCode(code, productHandle)).pipe(map(response => ({ ...response, code })))
  }
}

export function validateReferralCode(code: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(net.validateReferralCode(code)).pipe(map(response => ({ ...response, code })))
  }
}

export function validateVerificationCode(ott: string, code: string) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(net.validateVerificationCode(ott, code)).pipe(map(response => ({ ...response, code })))
  }
}

export function resendVerificationCode(ott: string) {
  return (dispatch: StoreThunkDispatch) => dispatch(net.resendVerificationCode(ott))
}
